import { render } from "./file.vue?vue&type=template&id=4da70c90&scoped=true&ts=true"
import script from "./file.vue?vue&type=script&lang=ts"
export * from "./file.vue?vue&type=script&lang=ts"

import "./file.vue?vue&type=style&index=0&id=4da70c90&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da70c90"]])

export default __exports__